import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PublicStats {
  sites_count: number;
  articles_count: number;
  models_count: number;
  last_updated: string;
}

async function fetchPublicStats(): Promise<PublicStats> {
  const { data, error } = await supabase.functions.invoke<PublicStats>("marketing-public-stats", {
    method: "GET",
  });
  if (error) throw error;
  return data as PublicStats;
}

export function usePublicStats() {
  return useQuery<PublicStats>({
    queryKey: ["marketing-public-stats"],
    queryFn: fetchPublicStats,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    // Fail-soft: surface the loading state but never block the hero render
    // with an error throw — the consumer falls back to seed numbers.
    throwOnError: false,
  });
}
